var table_viewer_default = {
  "root": "RnNNQ",
  "viewMode": "DeoZ6",
  "editMode": "u2uXq",
  "container": "aaGS7",
  "tableViewport": "q0RQT",
  "cell": "l2aGZ"
};
export {
  table_viewer_default as default
};
//# sourceMappingURL=table-viewer-scss.js.map
